module.exports = __webpack_public_path__ + "img/texture.89b51515.svg";